import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['header']

  // Checks if a focused element is behind a sticky header (which is an a11y issue),
  // and will scroll to unobscure the element
  headerTargetConnected(header) {
    $('#page-content').on('focusin', function() {
      // Top of the focused element
      const focusedElementTop = document.activeElement.getBoundingClientRect().top
      // Bottom of the header
      const headerBottom = header.offsetTop + header.offsetHeight

      // If the top of the focused element is above the bottom of the header, we should automatically
      // scroll to place the focused element below the header (with a small 40px buffer between them)
      if (focusedElementTop < headerBottom) {
        const scrollY = focusedElementTop + window.scrollY - header.offsetHeight - 40
        window.scrollTo(0, scrollY)
      }
    })
  }
}
